export default {
    countdown(gy, gm, gd, ghour, gmin, gsec, house) {
        let now = new Date();
        let goal = new Date(gy, gm - 1, gd, ghour, gmin, gsec);
        if (goal <= now) {
            let count = ["--", "--", "--", "--"];
            return count;
        } else {
            let diff = goal.getTime() - now.getTime();
            let s = Math.floor(diff / 1000) % 60;
            let m = Math.floor(diff / 1000 / 60) % 60;
            let h = Math.floor(diff / 1000 / 60 / 60) % 24;
            let d = Math.floor(diff / 1000 / 60 / 60 / 24);
            let h_s = ((h < 10) ? "0" : "") + h;
            let m_s = ((m < 10) ? "0" : "") + m;
            let s_s = ((s < 10) ? "0" : "") + s;
            let count = [d, h_s, m_s, s_s];
            return count;
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/countdown.js